import script from "./IciButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./IciButton.vue?vue&type=script&setup=true&lang=ts"

import "./IciButton.vue?vue&type=style&index=0&id=0a906094&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a906094"]])

export default __exports__